import { Company } from "./company.model"
import { Device } from "./device.model"
import { SearchModels } from "./search-filter.model"

export class WarnNotification{
    public id?:number
    public title?:string
    public message?:string
    public deviceId?:string
    public type?:string
    public isLocationCorrect?:boolean
    public companyId?:number
    public createdAt?:Date
    public device?:Device
    public company?:Company
}
export class WarnNotificationSearchModel{
    public title?:SearchModels = {
        search_field:"Title",
        search_value:""
      };
    public message?:SearchModels = {
        search_field:"Message",
        search_value:""
      };
    public type?:SearchModels = {
        search_field:"Type",
        search_value:""
      };
    public isLocationCorrect?:SearchModels = {
        search_field:"IsLocationCorrect",
        search_value:""
      };
    public deviceId?:SearchModels = {
        search_field:"DeviceId",
        search_value:""
      };
    public createdAt?:SearchModels = {
        search_field:"CreatedAt",
        search_value:""
      };
}